import { ListSortDirection, Sort } from "../../models/api/sort";
import { RevenueExpenseTypeDTO, RevenueExpenseTypeSTO } from "../../models/revenue-expense-type";
import { BaseApiService } from "../base";

export class RevenueExpenseTypesApiService extends BaseApiService<RevenueExpenseTypeDTO, RevenueExpenseTypeSTO> {
  constructor() {
    super({
      servicePath: "/RevenueExpenseTypes",
      loadItemsPath: "/GetRevenueExpenseTypes",
      saveItemsPath: "/SaveRevenueExpenseTypes",
    });
    this.defaultSort = [
      {
        name: "sequence",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
